import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AddBanner from './AddBanner';
// import Student from '../../../pages/User';
import BannerTable from './BannerTable';
import AddYoutube from './AddYoutbe';
import YoutubeTable from './YoutubeTable';
import { useTheme } from '@emotion/react';
import YoutubeTable1 from './YoutubeTable1';
import getAccess from '../../../utils/getAccess';
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const Youtube = () => {
    const access = getAccess();
    const theme = useTheme()


    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{ width: '100%', }}>
                    <Tab label="All Youtube Videos" sx={{ width: '100%' }} {...a11yProps(0)} />
                    {(access?.access?.includes('1044') || access?.access.includes('all')) && (<Tab label="Add Youtube" sx={{ width: '100%' }} {...a11yProps(1)} />)}
                    {/* <Tab label="Item Three" sx={{ width: '100%' }} {...a11yProps(2)} /> */}
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                {/* <YoutubeTable /> */}
                <YoutubeTable1 />
            </TabPanel>
            {(access?.access?.includes('1044') || access?.access.includes('all')) && (<TabPanel value={value} index={1}>
                <AddYoutube />
            </TabPanel>)}

        </Box >
    );
}

export default Youtube